<template>
  <v-chip small :color="color" :text-color="textColor" label>
    {{ label }}
  </v-chip>
</template>

<script>
const STATUS_MAP = {
  active: { label: 'Activa', color: 'green lighten-4', textColor: 'green darken-4' },
  trialing: { label: 'Prueba', color: 'blue lighten-4', textColor: 'blue darken-4' },
  past_due: { label: 'Vencida', color: 'orange lighten-4', textColor: 'orange darken-4' },
  canceled: { label: 'Cancelada', color: 'grey lighten-2', textColor: 'grey darken-3' },
  expired: { label: 'Expirada', color: 'red lighten-4', textColor: 'red darken-4' },
};

export default {
  name: 'SubscriptionStatusChip',
  props: {
    status: {
      type: String,
      default: 'active',
    },
  },
  computed: {
    config() {
      return STATUS_MAP[this.status] || { label: this.status, color: 'grey lighten-3', textColor: 'grey darken-2' };
    },
    label() {
      return this.config.label;
    },
    color() {
      return this.config.color;
    },
    textColor() {
      return this.config.textColor;
    },
  },
};
</script>
